<template>
  <page-wrapper :title="title">
    <loading-overlay :active="isLoading" />
    <div v-if="!isCallCenter" class="header">
      <sc-button
        :route="createButton.route"
        class="create-button"
        variant="primary"
        >{{ createButton.text }}</sc-button
      >
    </div>
    <div>
      <collection-list-item
        v-for="item in list"
        :key="item.id"
        v-bind="item"
      ></collection-list-item>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import LoadingOverlay from "@/lib/components/LoadingOverlay";
import { baanRueJaiClient } from "@/dependencies";
import CollectionListItem from "../components/CollectionListItem";
import { mapCollectionListItem } from "../mapCollectionListItem";

export default {
  name: "CollectionListPage",
  components: {
    PageWrapper,
    CollectionListItem,
    ScButton,
    LoadingOverlay
  },
  data() {
    const title = "รายการแพ็กเกจใหญ่";
    const createButton = {
      text: "เพิ่มแพ็กเกจใหญ่",
      route: { name: "CollectionCreatePage" },
    };
    const list = [];

    return {
      title,
      list,
      createButton,
      isLoading: false
    };
  },
  computed: {
    isCallCenter() {
      return localStorage.getItem("adminRoleId") === "4";
    },
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      this.isLoading = true;
      const list = await this.fetchList();

      this.list = list.map(mapCollectionListItem);
      this.isLoading = false;
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.subscriptions.collections.list();

      return response.data.result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
  border-bottom: $border;
}
</style>
